import {gql} from "@apollo/client"



export const COUNTGLOBAL = gql`
 
 mutation updateGlobal ($input:GlobalInput){
  updateGlobal(input:$input)
}

 

 
  `;

export const GETGLOBAL = gql`
query getGlobal($id :ID!){
  getGlobal(id: $id) {

    createAt
    countGlobal
    countInt
    createAt2
    idUser{
    id
      
      username
      avatar
      area
      
    }
    idUserAnt{
    id
      
      username
      avatar
      area
      
    }
    idUserAnt2{
    id
      
      username
      avatar
      area
      
    }


    
  }
}

`;